module.exports = __webpack_public_path__ + "img/taur_hs_large.0d17b7ed.jpg";